import type { GrantId } from "@storytell/types";
import type { ActiveContextStore } from "../activeContext/activeContextStore";

export type GrantsService = ReturnType<typeof createGrantsService>;

export const createGrantsService = (deps: { activeContext: ActiveContextStore }) => {
  const canCreate = (id: GrantId): boolean => deps.activeContext.canAt("project", id, "op.create");
  const canUpdate = (id: GrantId): boolean => deps.activeContext.canAt("project", id, "op.update");
  const canDelete = (id: GrantId): boolean => deps.activeContext.canAt("project", id, "op.delete");

  // Scope-aware: a matrix from the previous project must not satisfy this,
  // or gates would silently apply the wrong roles.
  const isLoaded = (): boolean => deps.activeContext.isLoadedForCurrentScope();

  return {
    canCreate,
    canUpdate,
    canDelete,
    isLoaded,
  };
};
